import {
  Container,
  Row,
  Col,
  Button,
} from "react-bootstrap";
import { VscCheckAll } from "react-icons/vsc";

const HeroSection = ({ showChat, setShowChat, heroSection, scrollToSection, themeColor, sendNotification }) => {
  return (
    <>
      <div
        id="home"
        style={{
          paddingTop: "40px",
          paddingBottom: "40px",
          display: "flex",
          alignItems: "center",
          background: `linear-gradient(360deg, ${themeColor} -700%, #eef2ff30)`,
        }}
      >
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              {heroSection?.heroBadgeTitle &&
                <div className="badge mb-3" style={{backgroundColor: themeColor, borderColor: themeColor}}>
                  {heroSection?.heroBadgeTitle}
                </div>
              }
              <h1 className="display-4 fw-bold">
                {heroSection?.heroHeading}
              </h1>
              <p className="fs-5 text-muted mt-3" style={{ maxWidth: 520 }}>
                {heroSection?.heroDescription}
              </p>
              <div className="mt-4 d-flex flex-wrap gap-3">
                {heroSection?.viewServicesButton &&
                  <Button
                    size="lg"
                    className="rounded-pill px-4"
                    style={{backgroundColor: themeColor, borderColor: themeColor}}
                    onClick={() => {sendNotification("navigate", `Visitor Navigated to the Services.`); scrollToSection("services")}}
                  >
                    View Services
                  </Button>
                }
                <Button
                  size="lg"
                  variant={heroSection?.viewServicesButton ? "outline-secondary" : "primary"}
                  className="rounded-pill px-4"
                >
                  Chat with Me
                </Button>
              </div>
              {(heroSection?.heroHighLightedKey || [])?.length > 0 &&
                <div className="mt-4 text-muted small">
                  {(heroSection?.heroHighLightedKey || [])?.map((item, index) => (
                    <span key={index} className="me-3"><VscCheckAll className="mb-1" style={{color: themeColor}} /> {item?.title}</span>
                  ))}
                </div>
              }
            </Col>
            <Col md={6} className="text-center d-none d-md-block">
              <img
                src="https://i.pravatar.cc/420?img=3"
                alt="Roop Chandra"
                className="img-fluid rounded-4 shadow-lg"
                style={{ maxHeight: 420 }}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default HeroSection;
